import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'orphan-variants',
            label: 'orphan-variants.nav',
            routerLink: ['/extensions/orphan-variants'],
            icon: 'recycle',
            requiresPermission: (userPermissions) =>
                userPermissions.includes('ReadProduct') ||
                userPermissions.includes('ReadSettings'),
        },
        'catalog'
    ),
];
